import React, { useEffect, useRef } from 'react';
import { loadScript } from '@buzzfeed/bf-utils';
import styles from './google-preferred-sources-button.module.scss';

const GOOGLE_PREFERRED_SOURCES_SCRIPT_ID = 'google-preferred-sources-script';
const GOOGLE_PREFERRED_SOURCES_SCRIPT_SRC = 'https://news.google.com/swg/js/v1/publisher.js';
const GOOGLE_PREFERRED_SOURCES_BUTTON_ATTRIBUTE = 'google-add-preferred-source-btn';

const GooglePreferredSourcesButton = ({ buzz }) => {
  const buttonRef = useRef(null);
  const timingTags = buzz?.laser_tags?.bf_content_description?.post_timing || [];
  const isEligible =
    !buzz?.isPreview &&
    (timingTags.some(tag => tag?.tag_name === 'timely') || buzz?.isQuiz);

  useEffect(() => {
    if (!isEligible) {
      return;
    }

    if (document.getElementById(GOOGLE_PREFERRED_SOURCES_SCRIPT_ID)) {
      return;
    }

    loadScript(GOOGLE_PREFERRED_SOURCES_SCRIPT_SRC, document.head, true, {
      id: GOOGLE_PREFERRED_SOURCES_SCRIPT_ID,
    });
  }, [isEligible]);

  if (!isEligible) {
    return null;
  }

  return (
    <div className={styles.wrapper}>
      <div
        ref={buttonRef}
        {...{ [GOOGLE_PREFERRED_SOURCES_BUTTON_ATTRIBUTE]: '' }}
      />
    </div>
  );
};

export default GooglePreferredSourcesButton;